export const LEXICON_LETTERS_LOWER = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
] as const

export type LEXICON_LETTER_TYPE = typeof LEXICON_LETTERS_LOWER

export const isValidLexiconLetter = (
  lexiconLetterType: LEXICON_LETTER_TYPE | undefined | null
) => {
  if (!lexiconLetterType) return false
}
